<section id="contact" name="contact"></section>
<!--  FOOTER DESCRIPTION   -->
<div id="footwrap">
	<div class="container">
		<div class="row">
			<div class="col-lg-2 col-lg-offset-1">
				<h5><i class="fa fa-envelope"></i> CONTACT</h5>
			</div>
			<div class="col-lg-6">
				<p>
					<i>Email</i><br />
					<a href="mailto:vincent.megia@gmail.com">vincent.megia@gmail.com</a>
					<br />
				</p>
				<p>
					<i>Resume</i><br />
					<a href="/assets/resume.pdf" download="vincent-megia.zip">Download</a>
					<br />
				</p>
			</div>
			<div class="col-lg-3">
				<p>
					<i>SOCIAL LINKS</i>
				</p>
				<p>
					<a target="_blank" href="http://iamstupendous.wordpress.com"
						><i style="font-size: 2em" class="fa fa-wordpress"></i
					></a>
					<a target="_blank" href="http://github.com/vincentmegia"
						><i style="font-size: 2em" class="fa fa-github"></i
					></a>
					<a target="_blank" href="https://www.linkedin.com/in/vincent-megia/"
						><i style="font-size: 2em" class="fa fa-linkedin"></i
					></a>
				</p>
			</div>
		</div>
	</div>
</div>
